import littleProblem from "../../../assets/little-problem.svg";
import notFound from "../../../assets/not-found.svg";

const MessageCodes = {
  400: {
    message: "Oops, there was a problem completing your request",
  },
  403: {
    message: "Whoa there, you are not authorised to perform that request",
  },
  404: {
    message: "The page you’re looking for can’t be found",
    subtitle: "Please try again or search for a delivery above.",
    icon: notFound,
  },
  408: {
    message: "This request took longer than expected, please try again",
  },
  default: {
    message: "We have a little problem",
    subtitle:
      "It looks like we encountered an issue when trying to display this information.",
  },
};

const getErrorData = error => {
  // for 403 you should use customer error message
  // different message on different project from backend. For example:  https://geopost.jira.com/browse/CC-1358
  if (
    error.statusCode === 403 &&
    error.errors &&
    error.errors[0] &&
    error.errors[0].message
  ) {
    return {
      message: "Access Denied",
      subtitle: error.errors[0].message,
    };
  }
  return MessageCodes[error.statusCode] || MessageCodes.default;
};

const preloadImg = imgUrl => {
  const linkElement = document.createElement("link");
  linkElement.setAttribute("rel", "preload");
  linkElement.setAttribute("href", imgUrl);
  linkElement.setAttribute("as", "image");

  document.head.appendChild(linkElement);
};

[littleProblem, notFound].forEach(preloadImg);

class LoaderError extends Error {
  constructor(error) {
    super();
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, LoaderError);
    }
    this.name = "LoaderError";
    const errorData = getErrorData(error);

    this.message = errorData.message;
    this.subtitle = errorData.subtitle;
    this.icon = errorData.icon || littleProblem;
  }
}

LoaderError.CODE_TO_MESSAGE = MessageCodes;

export default LoaderError;
